import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';

/**
 * here we're dropping new bunch of symbols at the beginning of spin after the old ones are gone
 */
export class AvalancheReelsDropNewState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	public onEnterState(): void {
		if (this.module.isSpinResponseReceived) {
			this.dropNewSymbols();
		}
	}

	public onLeaveState(): void {
	}

	protected dropNewSymbols(): void {
		throw new Error('AvalancheReelsDropNewState::dropNewSymbols must be overridden');
	}

	protected setupEvents(): void {
		this.on(AvalancheReelsView.ALL_REELS_DROPPED_NEW, this.onAllReelsDroppedNew);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
	}

	protected onAllReelsDroppedNew(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
		this.emit(ReelsEvents.SPIN_ENDED);
	}

	protected onSpinResponse(): void {
		this.dropNewSymbols();
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsDropNewState.ts